var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpvNavLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_145_67",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#174082}.cls-3{fill:#0663e2;opacity:.2}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1594",
    fill: "none",
    d: "M0 0H23V23H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6336",
    transform: "translate(215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    d: "M-195.824 8.39a1.4 1.4 0 0 0-.737-1.2 1.428 1.428 0 0 0-1.433.019l-1.929 1.094a1.673 1.673 0 0 0-1.667-1.38h-7.92a1.659 1.659 0 0 0-1.69 1.627v6.15a1.592 1.592 0 0 0 .492 1.151 1.706 1.706 0 0 0 1.2.478h7.939a1.666 1.666 0 0 0 1.673-1.434l1.936 1.09a1.485 1.485 0 0 0 .727.2 1.589 1.589 0 0 0 .705-.177 1.332 1.332 0 0 0 .728-1.208zm-1.324 6.423a.074.074 0 0 1-.041.068h-.086l-.007.005-2.6-1.473v-3.6l2.587-1.49h.077a.105.105 0 0 1 .052.08zm-4.079-.107a.341.341 0 0 1-.348.333h-7.941a.342.342 0 0 1-.342-.336V8.568a.342.342 0 0 1 .349-.333h7.945a.342.342 0 0 1 .342.337v5.915h-.007z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    d: "M-192.918 6.926h-1.5V2.418h-4.382v-1.5h5.882z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    d: "M-212.582 6.926h-1.5V.918h5.882v1.5h-4.382z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    d: "M-208.2 22.082h-5.882v-5.756h1.5v4.256h4.382z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    d: "M-192.918 22.082h-5.882v-1.5h4.382v-4.256h1.5z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    d: "M-202.054 14.064a.269.269 0 0 1-.282.256h-6.417a.27.27 0 0 1-.277-.258v-4.71a.27.27 0 0 1 .282-.256h6.421a.271.271 0 0 1 .277.258V13.9h-.006z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    d: "M-197.747 13.768a.073.073 0 0 1-.041.068h-.093l-1.452-.79V10.2l1.436-.809h.077a.105.105 0 0 1 .052.08z",
    className: "cls-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpvNavLogo);
export default __webpack_public_path__ + "static/media/ipvNavLogo.95ece07ad8cf691e536264219be4f830.svg";
export { ForwardRef as ReactComponent };